import React, {Fragment} from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from "react-redux";
import _isEqual from "lodash/isEqual";
import {Redirect} from 'react-router-dom';
import {
    Button,
    TextField,
} from '@material-ui/core';

import {
    forgotPassword,
    changeForgotPasswordForm,
    resetForgotPasswordForm,
    userExist
} from '../../vendors/actions/user';
import {ClockLoader} from "react-spinners";
import MuiAlert from "@material-ui/lab/Alert/Alert";

interface OwnProps {
    userExist?: any,
    forgotPassword?: any,
    changeForgotPasswordForm?: any,
    resetForgotPasswordForm?: any,
}

interface MainState {
    user: any,
    form: any,
    apiError: boolean
    loading: boolean
    success: boolean,
    redirect: string
}

interface ConnectStateProps {
    User: any,
    ForgotPasswordForms: any
}

interface ConnectDispatchProps {
    userExist?: (data: any) => void,
    forgotPassword?: (data: any) => void,
    changeForgotPasswordForm?: (data: any) => void,
    resetForgotPasswordForm?: () => void,
}


type HeaderProps = OwnProps & ConnectStateProps & ConnectDispatchProps;


class SendEmail extends React.Component<HeaderProps, MainState> {
    state = {
        user: null,
        apiError: false,
        loading: false,
        success: false,
        redirect: '',
        form: {
            email: {
                value: '',
                error: false,
                dirty: false
            }
        }
    };

    componentWillUnmount(): void {
        this.props.resetForgotPasswordForm()
    }

    static getDerivedStateFromProps(props: any, state: any) {
        const {ForgotPasswordForms} = props;
        if (ForgotPasswordForms && (!_isEqual(state.form.email, ForgotPasswordForms.data.email))) {
            return {
                form: ForgotPasswordForms.data
            };
        }
        return null;
    }

    setEmail = (e: any) => {
        const value = e.target.value;
        this.props.changeForgotPasswordForm({value, field: 'email'});
    };

    validate(value: any) {
        this.props.changeForgotPasswordForm({value, field: 'email', validate: true});
    }

    async checkUser(email: any) {
        const res = await this.props.userExist({email});

        !res.payload.exists && this.props.changeForgotPasswordForm({
            value: email,
            field: 'email',
            apiError: true
        });
        console.log('res',res)

        return res.payload.exists
    }

    goHome() {
        this.setState({ redirect: "/dashboard" })
    }

    async submit() {
        const {ForgotPasswordForms} = this.props;
        const email = ForgotPasswordForms.data.email.value;

        this.validate(email);
console.log('1',email)
        if (email && !ForgotPasswordForms.data.email.error) {

            if (!(await this.checkUser(ForgotPasswordForms.data?.email?.value))) return;

            this.setState({loading: true});

            const res = await this.props.forgotPassword({email});

            if (res?.error_id && res.error_id !== '400_2') {
                this.setState({
                    apiError: res?.message,
                    loading: false
                })
            } else {
                this.setState({success: true});
            }
        }
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to={this.state.redirect} />
        }

        const {form, apiError, loading, success} = this.state;

        return (
            <Fragment>
                {success && <div>
                    <MuiAlert className="mb-4" severity="success">
                    <div className="d-flex align-items-center align-content-center">
                          <span>
                          <strong className="d-block">Please check your email.</strong>
                              To reset your password follow the instructions sent to your <strong>{form.email.value}</strong> address.
                          </span>
                    </div>
                </MuiAlert>
                    <div className={'text-left mt-4'}>
                        <Button
                            onClick={() => this.goHome()}
                            variant="contained"
                            color="primary"
                            className=" and-lawyers-button">Go Back
                        </Button>
                    </div>
                </div>}
                {!success && (loading ? <div
                        className="d-flex align-items-center justify-content-center clock--loader">
                        <ClockLoader color={'var(--primary)'} loading={true}/>
                    </div> :
                    <div className="">
                        <form className="">
                            <div className='input-wrapper'>
                                <TextField
                                    fullWidth
                                    error={!!form?.email?.error && form?.email?.dirty }
                                    helperText={form?.email?.dirty && form?.email?.error ? form?.email?.error : ''}
                                    onChange={this.setEmail}
                                    onBlur={(e)=> this.validate(e?.target?.value)}
                                    label="Email"
                                    id="email"
                                    variant="outlined"
                                />
                            </div>
                            {apiError &&
                            <p className="MuiFormHelperText-root Mui-error MuiFormHelperText-filled"> {apiError}</p>}
                            <div className='button-wrapper'>
                                <Button
                                    onClick={() => this.submit()}
                                    variant="contained"
                                    color="primary"
                                    className="and-lawyers-button">Reset Password
                                </Button>
                            </div>
                        </form>
                    </div>)}
            </Fragment>
        )
    }
}

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {User, ForgotPasswordForms} = state;
    return {
        User,
        ForgotPasswordForms
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        userExist: (data: any) => dispatch(userExist(data)),
        forgotPassword: (data: any) => dispatch(forgotPassword(data)),
        changeForgotPasswordForm: (data: any) => dispatch(changeForgotPasswordForm(data)),
        resetForgotPasswordForm: () => dispatch(resetForgotPasswordForm())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SendEmail);
